/**
 * @generated SignedSource<<41ecbb84fd2fa9744d0269406d5ec488>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfo_seller$data = {
  readonly monthsSinceStartDate: number | null;
  readonly serviceId: string | null;
  readonly isDistinguished: boolean | null;
  readonly isRewardsTier2: boolean | null;
  readonly sellerTiers: {
    readonly isGoldTier: boolean | null;
    readonly isPlatinumTier: boolean | null;
    readonly sellerTierDataNotFound: boolean | null;
  } | null;
  readonly orderFeedbackPdp: {
    readonly metadata: {
      readonly aggregatedFeedback: {
        readonly overallExperience: {
          readonly mean: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly sellerProfile: {
    readonly company: string | null;
  } | null;
  readonly tradeAssociations: ReadonlyArray<{
    readonly serviceId: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedStarRating_seller">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfo_seller";
};
export type PdpRespSidebarSellerInfo_seller$key = {
  readonly " $data"?: PdpRespSidebarSellerInfo_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfo_seller">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfo_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedStarRating_seller"
    },
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDistinguished",
      "storageKey": null
    },
    {
      "alias": "isRewardsTier2",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "kind": "ScalarField",
      "name": "isAnchorListMember",
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerTiers",
      "kind": "LinkedField",
      "name": "sellerTiers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGoldTier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPlatinumTier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sellerTierDataNotFound",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryConnection",
      "kind": "LinkedField",
      "name": "orderFeedbackPdp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackType",
              "kind": "LinkedField",
              "name": "aggregatedFeedback",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AggregatedOrderFeedbackQuestionType",
                  "kind": "LinkedField",
                  "name": "overallExperience",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mean",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerProfile",
      "kind": "LinkedField",
      "name": "sellerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeAssociation",
      "kind": "LinkedField",
      "name": "tradeAssociations",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})();

(node as any).hash = "30f4594ad3f8dbb3c2c2e67699460dc5";

export default node;
